import ApiClient from "~/admin/services/ApiClient";

export default class DocumentsApi {
  static validateDocument = (documentId) =>
    ApiClient.patch(`documents/valid/${documentId}`);
  static invalidateDocument = (documentId) =>
    ApiClient.patch(`documents/invalid/${documentId}`);
}
